<template>
    <article>
        <div>
            <files-gallery 
                v-if="gallery && product.files.length > 0" 
                :settings="product.settings"
                :listing="product.files" 
                :pageable="true" 
                :animate="false" />
            <section class="copy" v-html="product.description" />
            <section class="copy">
                <snippet-content slug="products" />
            </section>
        </div>
    </article>
</template>

<script>
import { filesComputed } from '@/features/files/store'
export default {
    props: {        
        product: {
            type: [Boolean,Object],
            required: false,
            default: () => (false)
        },
        gallery: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...filesComputed,
        uri(){
            if (!this.product) return false
            let test = this.product.files
            if (test.length == 0)
                return 'No Image Found'
            return test[0].uri
        }
    }
}
</script>